var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcInfoCircleMini(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_169_993)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0052 2.64673C5.40521 2.64673 1.67188 6.38006 1.67188 10.9801C1.67188 15.5801 5.40521 19.3134 10.0052 19.3134C14.6052 19.3134 18.3385 15.5801 18.3385 10.9801C18.3385 6.38006 14.6052 2.64673 10.0052 2.64673ZM10.8385 15.1467H9.17188V10.1467H10.8385V15.1467ZM10.8385 8.48006H9.17188V6.8134H10.8385V8.48006Z",
    fill: "#DFDBD6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_169_993"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.00488281 0.97998)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcInfoCircleMini);
export default __webpack_public_path__ + "static/media/ic_info_circle_mini.a7c6edfa4868d9f8e541051bf2d42bc3.svg";
export { ForwardRef as ReactComponent };